import PropTypes from "prop-types";

export const externalRedirectPropTypes = {
  /** The path to redirect to when "rendered". */
  to: PropTypes.string.isRequired,
};
